{
  "version": 1,
  "asset_id": "bfc1c180-0616-40f4-88f8-da52932d6046",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/bfc1c180-0616-40f4-88f8-da52932d6046/sleeve-hiatal-type-1-600.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/bfc1c180-0616-40f4-88f8-da52932d6046/sleeve-hiatal-type-1-600.webp",
  "original_filename": "sleeve-hiatal-type-1-600.webp",
  "size": 52288,
  "content_type": "image/webp",
  "created_at": "2026-09-26T21:30:27Z"
}
